import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DeviceConfigurationModel} from '../../../../models/configuration/device-configuration.model';
import {DevicesService} from '../../devices/devices.service';

@Component({
  selector: 'app-select-device-dlg',
  templateUrl: './select-device-dlg.component.html',
  styleUrls: ['./select-device-dlg.component.scss']
})
export class SelectDeviceDlgComponent implements OnInit {
  message = 'Select Device';
  isErrorFindingDevices = false;
  devices: DeviceConfigurationModel[];
  selectedDevice: DeviceConfigurationModel;
  isConfirmDisabled: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<SelectDeviceDlgComponent>,
    private devsService: DevicesService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    const locId = this.data.LOCID.toString();
    this.devsService.getDevices(locId).subscribe(ddata => {
      this.devices = ddata;
    }, err => {
      console.log(err);
    });

  }
  confirm() {
    console.log('selectedDevice ', this.selectedDevice);
    this.dialogRef.close(this.selectedDevice);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
